// @ts-strict-ignore
import isEmpty from 'vanillas/isEmpty';
import isObject from 'vanillas/isObject';
import { getCvAccessToken } from '@carvana/core-auth';

const BASE_API_URL = `${process.env.CARVANA_APP_TRADES_API}/api` as const;
const BASE_API_URL_V1 = `${process.env.CARVANA_APP_TRADES_API}/api/v1`;
const BASE_API_URL_V2 = `${process.env.CARVANA_APP_TRADES_API}/api/v2`;
const BASE_API_URL_V3 = `${process.env.CARVANA_APP_TRADES_API}/api/v3`;
const BASE_API_URL_V4 = `${process.env.CARVANA_APP_TRADES_API}/api/v4`;
const BASE_API_URL_V5 = `${process.env.CARVANA_APP_TRADES_API}/api/v5`;

const getVersionBase = version => {
  switch (version) {
    case 1:
      return BASE_API_URL_V1;
    case 2:
      return BASE_API_URL_V2;
    case 3:
      return BASE_API_URL_V3;
    case 4:
      return BASE_API_URL_V4;
    case 5:
      return BASE_API_URL_V5;
    default:
      return BASE_API_URL_V1;
  }
};

const getTradesApiPathHelper = (controller, resource, version) => {
  const baseApi = getVersionBase(version);
  const base = `${baseApi}/${controller}`;
  const withResource = `${base}${!isEmpty(resource) ? '/' : ''}${resource}`;
  return `${withResource}`;
};

const getTradesApiPathv3 = (controller, resource) =>
  getTradesApiPathHelper(controller, resource, 3);

const getAuthorization = () => {
  const token = getCvAccessToken();
  
  if (!token) {
    return '';
  }
  
  return `Bearer ${token}`;
};

const getHeaders = () => {
  const header = {
    headers: {
      Authorization: getAuthorization()
    }
  };
  header.headers['Content-Type'] = 'application/json';

  return header;
};

const getErrorCode = (error?: { response?: { status: number } }) =>
  error && error.response ? error.response.status : '';

const getErrorMessage = (error?: {
  message: string;
  response?: { data?: { message?: string; errorMessage?: string } | string };
}) => {
  if (!error) {
    return '';
  }

  if (error.response) {
    const responseData = error.response.data;

    if (typeof responseData === 'string') return responseData;

    if (isObject(responseData)) {
      const { message } = responseData;
      if (typeof message === 'string') return message;

      const { errorMessage } = responseData;
      if (errorMessage) return errorMessage;
    }
    return responseData;
  }
  return error.message;
};

const buildUrl = parts => getTradesApiPathHelper(parts.controller, parts.resource, parts.version);

export { BASE_API_URL, buildUrl, getErrorCode, getErrorMessage, getHeaders, getTradesApiPathv3 };
